import destinarioCover from "../../../assets/svg/descinario-cover.png";
import movieIdeaCover from "../../../assets/svg/movieidea-cover.png";
import avocadoCover from "../../../assets/svg/avocado-cover.png";
import aidenteCover from "../../../assets/svg/aidente-cover.png";
import kpopCover from "../../../assets/svg/kpop-cover.png";
import florishCover from "../../../assets/svg/florish-cover.png";
import crystalCover from "../../../assets/svg/crystal-cover.png";
import pimpinCover from "../../../assets/svg/pimpin-cover.png";
import jollyCover from "../../../assets/svg/jolly.png";
import bestiqCover from "../../../assets/svg/bestiq-cover.png";
// 2x PNG composites built from the rasters embedded in FrameN.svg (4-7.7 MB
// each, so they decoded visibly later than the main phone). Each phone's
// 6.58deg tilt is baked in, laid out as in Figma. Don't render the SVGs
// directly: Figma exports a rotated image fill as a rotated clip path over an
// unrotated image stretched to its bounding box, which cuts off the phones'
// top corners.
import Frame1 from "../../../assets/svg/Frame1.png";
import Frame2 from "../../../assets/svg/Frame2.png";
import Frame3 from "../../../assets/svg/Frame3.png";
import Frame4 from "../../../assets/svg/Frame4.png";
import Frame5 from "../../../assets/svg/Frame5.png";
import Frame6 from "../../../assets/svg/Frame6.png";
import Frame7 from "../../../assets/svg/Frame7.png";
import Frame8 from "../../../assets/svg/Frame8.png";
import Frame9 from "../../../assets/svg/Frame9.png";
import Frame10 from "../../../assets/svg/Frame10.png";


export const products = [
  {
    id: 1,
    name: "Destinario",
    type: "Online service",
    category: "Astrology",
    description: "Destinario is a modern astrology platform designed for true astro lovers, offering personalized horoscopes, in-depth predictions, detailed readings, and direct chat access to astrologer — all in one convenient space.",
    platforms: ["android", "ios", "web"],
    image: destinarioCover,
    imageRotated: Frame1
  },
  {
    id: 2,
    name: "MovieIdea",
    type: "Online service",
    category: "Entertainment",
    description:
      "Unlike traditional platforms with static catalogs, MovieAIdea leverages artificial intelligence to analyze user preferences and viewing habits to generate tailored suggestions. Each recommendation is unique — from popular releases to hidden gems — offering fresh discoveries every time. For those seeking spontaneity, the Random Suggestion feature provides an unexpected choice, making every movie night different.",
    platforms: ["android", "ios", "web"],
    image: movieIdeaCover,
    imageRotated: Frame2
  },
  {
    id: 3,
    name: "Avoca’DO",
    type: "Online service",
    category: "Well-being",
    description:
      "Avoca’DO is a wellness service with a personalized approach for each user. It focuses on four key areas: workout, sleep, nutrition, and water balance. The aim is to help users improve their physical health through guidance in these areas.",
    platforms: ["android", "ios", "web"],
    image: avocadoCover,
    imageRotated: Frame3
  },
  {
    id: 4,
    name: "AI Dente",
    type: "Online service",
    category: "Culinary",
    description:
      "AI Dente is an AI-driven recipe generator. Unlike traditional platforms with databases, AI Dente uses artificial intelligence to create recipes from scratch. Each result is unique and depends on the options chosen by the user.",
    platforms: ["android", "ios", "web"],
    image: aidenteCover,
    imageRotated: Frame4
  },
  {
    id: 5,
    name: "K-Poppin",
    type: "Online service",
    category: "Mainstream",
    description:
      "K Poppin is a guide to k-pop culture, offering music, dance moves, quizzes, challenges, and more. There's a dedicated fanbase in nearly every country. This is why our service will be an interesting entertainment option for the fans. ",
    platforms: ["android", "ios", "web"],
    image: kpopCover,
    imageRotated: Frame5
  },
  {
    id: 6,
    name: "Flourish",
    type: "Online service",
    category: "Well-being",
    description:
      "Flourish is a service that regulates the balance between body and soul. The service includes body care (yoga, fitness, healthy recipes, workout music) and soul nourishment (meditations, affirmation wallpapers, inspirational videos, relaxation music). The content updates every week.",
    platforms: ["android", "ios", "web"],
    image: florishCover,
    imageRotated: Frame6
  },
  {
    id: 7,
    name: "Crystal",
    type: "Online service",
    category: "Well-being",
    description:
      "Crystal is a service for mental wellness. Users may use it as a tool to find inner peace. It provides guided meditations, affirmation wallpapers, nature sounds, relaxing music, and inspiring videos.",
    platforms: ["android", "ios", "web"],
    image: crystalCover,
    imageRotated: Frame7
  },
  {
    id: 8,
    name: "Pimpin",
    type: "Online service",
    category: "Entertainment",
    description:
      "All-around service with categorized articles. Technology, games, health, culinary, movies, and astrology — all topics are available for reading.",
    platforms: ["android", "ios", "web"],
    image: pimpinCover,
    imageRotated: Frame8
  },
  {
    id: 9,
    name: "Jolly Jumble",
    type: "Online service",
    category: "Entertainment",
    description:
      "Jolly Jumble provides varied entertainment content in one service. It includes horoscope readings, wallpapers, videos, music, recipes, and tests.The service offers user-friendly navigation and content for downloading.",
    platforms: ["android", "ios", "web"],
    image: jollyCover,
    imageRotated: Frame9
  },
  {
    id: 10,
    name: "Best IQ",
    type: "Online service",
    category: "Test",
    description:
      "Best IQ is an intellectual service where users check their IQ, EQ, and erudition. The platform offers an interactive way for users to evaluate their cognitive abilities and gain insights into their intellectual strengths and weaknesses.",
    platforms: ["android", "ios", "web"],
    image: bestiqCover,
    imageRotated: Frame10
  },
];